// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mission {
  margin: 4rem 6rem;
}
.destination h1 {
  font-size: 3rem;
}
.first-mission {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4.5rem;
}
.mis-text {
  width: 100%;
  text-align: center;
  font-size: 1.1rem;
}
.des-text h2 {
  padding-bottom: 1rem;
}
.image {
  position: relative;
  width: 600px;
  display: flex;
  margin-left: 20px;
  justify-content: space-between;
  z-index: -99;
}

.image img {
  width: 49%;
  height: 350px;
  object-fit: cover;
  border-radius: 6px;
  box-shadow: -1px 1px 62px -18px rgba(0, 0, 0, 0.19);
}
.image img:nth-child(2) {
  position: absolute;
  top: -20%;
  right: 0;
}
@media screen and (max-width: 850px) {
  .destination {
    margin: 4rem 2rem;
  }
  .first-mission {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 2.5rem;
  }
  .mis-text{
    font-size: 1.1rem;
  }
  .des-text {
    width: 100%;
  }
  .image {
    width: 100%;
    margin: 1.8rem 0;
  }
  .image img {
  
    height: 250px;
   
  }
  
 
}
@media screen and (max-width: 430px) {
  .mission {
    margin: 4rem 0.5rem; /* Adjust margin as needed for smaller screens */
  }

  .mis-text {
    font-size: 1rem; /* Adjust font size for smaller screens */
  }

  /* Reduce the image height for smaller screens */
  .image img {
    height: 200px; /* Adjust image height for smaller screens */
    align-items: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/mission.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;;IAEE,aAAa;;EAEf;;;AAGF;AACA;EACE;IACE,mBAAmB,EAAE,gDAAgD;EACvE;;EAEA;IACE,eAAe,EAAE,yCAAyC;EAC5D;;EAEA,gDAAgD;EAChD;IACE,aAAa,EAAE,4CAA4C;IAC3D,iBAAiB;EACnB;AACF","sourcesContent":[".mission {\r\n  margin: 4rem 6rem;\r\n}\r\n.destination h1 {\r\n  font-size: 3rem;\r\n}\r\n.first-mission {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 4.5rem;\r\n}\r\n.mis-text {\r\n  width: 100%;\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n}\r\n.des-text h2 {\r\n  padding-bottom: 1rem;\r\n}\r\n.image {\r\n  position: relative;\r\n  width: 600px;\r\n  display: flex;\r\n  margin-left: 20px;\r\n  justify-content: space-between;\r\n  z-index: -99;\r\n}\r\n\r\n.image img {\r\n  width: 49%;\r\n  height: 350px;\r\n  object-fit: cover;\r\n  border-radius: 6px;\r\n  box-shadow: -1px 1px 62px -18px rgba(0, 0, 0, 0.19);\r\n}\r\n.image img:nth-child(2) {\r\n  position: absolute;\r\n  top: -20%;\r\n  right: 0;\r\n}\r\n@media screen and (max-width: 850px) {\r\n  .destination {\r\n    margin: 4rem 2rem;\r\n  }\r\n  .first-mission {\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    margin-top: 2.5rem;\r\n  }\r\n  .mis-text{\r\n    font-size: 1.1rem;\r\n  }\r\n  .des-text {\r\n    width: 100%;\r\n  }\r\n  .image {\r\n    width: 100%;\r\n    margin: 1.8rem 0;\r\n  }\r\n  .image img {\r\n  \r\n    height: 250px;\r\n   \r\n  }\r\n  \r\n \r\n}\r\n@media screen and (max-width: 430px) {\r\n  .mission {\r\n    margin: 4rem 0.5rem; /* Adjust margin as needed for smaller screens */\r\n  }\r\n\r\n  .mis-text {\r\n    font-size: 1rem; /* Adjust font size for smaller screens */\r\n  }\r\n\r\n  /* Reduce the image height for smaller screens */\r\n  .image img {\r\n    height: 200px; /* Adjust image height for smaller screens */\r\n    align-items: left;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
